import { Button, Tooltip } from '@vimeo/bokeh';
import { Eye, EyeShut } from '@vimeo/bokeh-icons';

import { T } from '../../translations';
import { FilterOptions } from '../../types';

type Props = {
  showResolved: boolean;
  updateFilterOptions: (newFilterOption: FilterOptions) => void;
};

export const ResolvedCommentFilter = ({ showResolved, updateFilterOptions }: Props) => {
  const changeShowResolved = (newShowResolved: boolean) => {
    const statusFilter = newShowResolved ? undefined : ('open' as const);
    updateFilterOptions({ status: statusFilter });
  };

  return (
    <Tooltip
      placement="top-start"
      label={showResolved ? T.HideResolvedComments : T.ShowResolvedComments}
    >
      <Button
        onClick={() => changeShowResolved(!showResolved)}
        variant="minimal"
        size="sm"
        aria-label={showResolved ? T.HideResolvedComments : T.ShowResolvedComments}
        leftIcon={showResolved ? <Eye /> : <EyeShut />}
      >
        {T.Resolved}
      </Button>
    </Tooltip>
  );
};
